import StepId from "@/model/progress/StepId"
import RouteType from "@/model/route/RouteType"
import { applicationState, sessionState } from "@/state"
import { navigationService } from "@/service"

export default [
    {
        path: "/home/apply/at_home",
        name: "atHomeApplyHome",
        redirect: () => {
            return navigationService.getRedirectLocation(
                navigationService.getProviderStartLocation(sessionState.providerKey, applicationState.applyMode)
            )
        },
    },
    {
        path: "/home/apply",
        name: "applyHome",
        component: () => import("@/views/apply/ApplyHomeView.vue"),
        meta: {
            stepper: false,
            title: "Home Page - Aspen Dental",
        },
    },
    {
        name: "startPrimaryProvider",
        path: "/providers/:providerKey/modes/:mode/primary/start",
        redirect: "/providers/:providerKey/modes/:mode/application",
    },
    {
        name: "startProvider",
        path: "/providers/:providerKey/modes/:mode/start",
        redirect: "/providers/:providerKey/modes/:mode/application",
    },
    {
        name: "switchProvider",
        path: "/providers/:providerKey/modes/:mode/switch",
        component: () => import("@/views/apply/SwitchProviderView.vue"),
    },

    {
        name: "application",
        path: "/providers/:providerKey/modes/:mode/application",
        meta: {
            routeType: RouteType.FIELD_COLLECTION,
            step: StepId.PATIENT_INFO,
        },
        component: () => import("@/views/apply/ApplicationView.vue"),
    },
    {
        name: "jointApplication",
        path: "/providers/:providerKey/modes/:mode/jointApplication",
        meta: {
            routeType: RouteType.FIELD_COLLECTION,
            step: StepId.JOINT_APPLICANT_INFO,
        },
        component: () => import("@/views/apply/JointApplicationView.vue"),
    },

    {
        name: "fullApplicationNext",
        path: "/providers/:providerKey/modes/full/applicationNext",
        meta: { step: StepId.TERMS },
        redirect: "/providers/:providerKey/terms",
    },

    {
        name: "prequalifyApplicationNext",
        path: "/providers/:providerKey/modes/prequalify/applicationNext",
        meta: { step: StepId.PATIENT_INFO },
        redirect: "/providers/:providerKey/prequalifyAgree",
    },

    {
        name: "prescreenApplicationNext",
        path: "/providers/:providerKey/modes/prescreen/applicationNext",
        meta: { step: StepId.PATIENT_INFO },
        redirect: "/providers/:providerKey/prequalifyAgree",
    },

    {
        name: "fullOfferReviewNext",
        path: "/providers/:providerKey/modes/full/offerReviewNext",
        meta: { step: StepId.PAYMENT_OPTIONS },
        redirect: "/providers/:providerKey/approved",
    },

    {
        name: "prequalifyOfferReviewNext",
        path: "/providers/:providerKey/modes/prequalify/offerReviewNext",
        meta: { step: StepId.ACCEPT_OFFER },
        redirect: "/providers/:providerKey/terms",
    },

    {
        name: "prescreenOfferReviewNext",
        path: "/providers/:providerKey/modes/prescreen/offerReviewNext",
        meta: { step: StepId.ACCEPT_OFFER },
        redirect: "/providers/:providerKey/terms",
    },

    {
        name: "checkCalifornia",
        path: "/providers/:providerKey/checkCalifornia",
        meta: {
            step: StepId.ACCEPT_OFFER,
            transient: true,
        },
        component: () => import("@/views/apply/CheckCaliforniaView.vue"),
    },

    {
        name: "checkCaliforniaNext",
        path: "/providers/:providerKey/checkCaliforniaNext",
        meta: { step: StepId.ACCEPT_OFFER },
        redirect: "/providers/:providerKey/terms",
    },

    {
        name: "approved",
        path: "/providers/:providerKey/approved",
        meta: { step: StepId.COMPLETE },
        component: () => import("@/views/apply/ApprovedView.vue"),
    },
    {
        name: "acceptOfferSubmit",
        path: "/providers/:providerKey/acceptOfferSubmit",
        meta: {
            step: StepId.ACCEPT_OFFER,
            transient: true,
        },
        component: () => import("@/views/apply/AcceptOfferSubmitView.vue"),
    },
    {
        name: "declined",
        path: "/providers/:providerKey/declined",
        meta: { step: StepId.COMPLETE, stepper: false },
        component: () => import("@/views/apply/DeclinedView.vue"),
    },
    {
        name: "error",
        path: "/providers/:providerKey/error",
        meta: { step: StepId.COMPLETE, stepper: false },
        component: () => import("@/views/apply/ErrorView.vue"),
    },
    {
        name: "offerReview",
        path: "/providers/:providerKey/offerReview",
        component: () => import("@/views/apply/OfferReviewView.vue"),
    },
    {
        name: "nooffer",
        path: "/providers/:providerKey/nooffer",
        meta: { step: StepId.COMPLETE },
        component: () => import("@/views/apply/NoOfferView.vue"),
    },
    {
        name: "pending",
        path: "/providers/:providerKey/pending",
        meta: { step: StepId.COMPLETE, stepper: false },
        component: () => import("@/views/apply/PendingView.vue"),
    },
    {
        name: "preapproved",
        path: "/providers/:providerKey/preapproved",
        redirect: "/providers/:providerKey/prequalified",
    },
    {
        name: "prequalified",
        path: "/providers/:providerKey/prequalified",
        redirect: "/providers/:providerKey/paymentPlans",
    },
    {
        name: "paymentPlans",
        path: "/providers/:providerKey/paymentPlans",
        meta: { step: StepId.PAYMENT_OPTIONS },
        component: () => import("@/views/apply/PaymentPlansView.vue"),
    },
    {
        name: "prequalifyAgree",
        path: "/providers/:providerKey/prequalifyAgree",
        meta: { step: StepId.PATIENT_INFO, disableProviderSwitch: true },
        redirect: "/providers/:providerKey/prequalifyAgreeNext",
    },
    {
        name: "prequalifyAgreeNext",
        path: "/providers/:providerKey/prequalifyAgreeNext",
        meta: { step: StepId.PATIENT_INFO, disableProviderSwitch: true },
        component: () => import("@/views/apply/PrequalifyAgreeNext.vue"),
    },
    {
        name: "prequalifySubmit",
        path: "/providers/:providerKey/prequalifySubmit",
        meta: {
            step: StepId.PATIENT_INFO,
            transient: true,
        },
        component: () => import("@/views/apply/PrequalifySubmitView.vue"),
    },
    {
        name: "patchSubmit",
        path: "/providers/:providerKey/patchSubmit",
        meta: {
            step: StepId.ACCEPT_OFFER,
            transient: true,
        },
        component: () => import("@/views/apply/PatchSubmitView.vue"),
    },

    {
        name: "fullApplicationSubmit",
        path: "/providers/:providerKey/fullApplicationSubmit",
        meta: {
            step: StepId.PAYMENT_OPTIONS,
            transient: true,
        },
        component: () => import("@/views/apply/FullApplicationSubmitView.vue"),
    },

    {
        name: "esignApplicationSubmit",
        path: "/providers/:providerKey/esignApplicationSubmit",
        meta: {
            step: StepId.PAYMENT_OPTIONS,
            transient: true,
        },
        component: () => import("@/views/apply/EsignApplicationSubmitView.vue"),
    },

    {
        name: "completeApplicationSubmit",
        path: "/providers/:providerKey/completeApplicationSubmit",
        meta: {
            step: StepId.PAYMENT_OPTIONS,
            transient: true,
        },
        component: () => import("@/views/apply/CompleteApplicationSubmitView.vue"),
    },

    {
        name: "patchSuccessful",
        path: `/providers/:providerKey/patchSuccessful`,
        redirect: "/providers/:providerKey/paymentPlans",
    },
    {
        name: "paymentPlanReview",
        path: "/providers/:providerKey/paymentPlanReview",
        meta: { step: StepId.PAYMENT_OPTIONS },
        component: () => import("@/views/apply/PaymentPlanReviewView.vue"),
    },
    {
        name: "resume",
        path: "/providers/:providerKey/resume",
        meta: { step: StepId.PATIENT_INFO, stepper: false },
        component: () => import("@/views/apply/ResumeView.vue"),
    },
    {
        name: "resumeAfterFullApply",
        path: "/providers/:providerKey/resume/after-full-apply",
        meta: { step: StepId.PATIENT_INFO, stepper: false },
        component: () => import("@/views/apply/ResumeAfterFullApplyView.vue"),
    },
    {
        name: "resumeFromOpen",
        path: "/providers/:providerKey/resume/from-open",
        redirect: _ => {
            return `/providers/:providerKey/modes/${applicationState.applyMode}/application`
        },
    },
    {
        name: "resumeWithExistingAccount",
        path: "/providers/:providerKey/resume/with-existing-account",
        redirect: "/providers/:providerKey/paymentPlans",
    },
    {
        name: "resumeFromPaymentPlanReview",
        path: "/providers/:providerKey/resume/from-payment-plan-review",
        redirect: "/providers/:providerKey/paymentPlanReview",
    },
    {
        name: "resumeFromPrequalifiedReview",
        path: "/providers/:providerKey/resume/from-prequalified",
        redirect: "/providers/:providerKey/prequalified",
    },
    {
        name: "terms",
        path: "/providers/:providerKey/terms",
        meta: { inheritStepFromRedirect: true },
        component: () => import("@/views/apply/ProviderOverrideView.vue"),
    },
    {
        name: "pass",
        path: "/providers/:providerKey/pass",
        meta: { step: StepId.ACCEPT_OFFER },
        component: () => import("@/views/apply/ProviderOverrideView.vue"),
    },
    {
        name: "fail",
        path: "/providers/:providerKey/fail",
        meta: { step: StepId.ACCEPT_OFFER },
        component: () => import("@/views/apply/ProviderOverrideView.vue"),
    },
    {
        name: "complete",
        path: "/providers/:providerKey/complete",
        meta: { step: StepId.COMPLETE },
        component: () => import("@/views/apply/ApprovedView.vue"),
    },
    {
        name: "existingAccount",
        path: "/providers/:providerKey/existingAccount",
        meta: { step: StepId.COMPLETE },
        component: () => import("@/views/apply/ExistingAccountView.vue"),
    },
    {
        name: "acceptOfferError",
        path: "/providers/:providerKey/acceptOfferError",
        meta: { step: StepId.COMPLETE, stepper: false },
        component: () => import("@/views/apply/ErrorView.vue"),
    },
]
